<template>
  <v-row>
    <v-col cols="12" xs="12" md="10">
      <v-row dense>
        <v-col cols="12" xs="12" md="4">
          <v-text-field
            v-model="form.name"
            :rules="rules.requiredTextLine"
            :label="`${$t('ITEM.NAME')} *`"
            :readonly="readonly"
            :error-messages="errors.name"
            @input="updateValue('name', $event)"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" md="4">
          <v-select
            v-model="form.language_id"
            :items="languages"
            :loading="!!!languages.length"
            item-value="id"
            item-text="name"
            :label="$t('PROFILE.LANGUAGE')"
            :readonly="readonly"
            :error-messages="errors.language_id"
            @change="updateValue('language_id', $event)"
          ></v-select>
        </v-col>
        <v-col cols="12" xs="12" md="4">
          <v-select
            v-model="form.status"
            :items="statuses"
            :loading="!!!statuses.length"
            :rules="rules.requiredTextLine"
            item-text="name"
            item-value="id"
            :label="$t('PROFILE.STATUS')"
            :error-messages="errors.status"
            :readonly="readonly"
            @change="updateValue('status', $event)"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" xs="12" md="4">
          <v-select
            v-model="form.type_ids"
            :loading="!!!types.length"
            :items="types"
            item-text="name"
            item-value="id"
            :rules="rules.requiredSelectArray"
            :label="`${$t('ITEM.TYPE')}`"
            :error-messages="errors.type_ids"
            multiple
            :readonly="readonly"
            @change="updateValue('type_ids', $event)"
          ></v-select>
        </v-col>
        <v-col cols="12" xs="12" md="4">
          <phone-input
            v-model="form.phone"
            :label="$t('PROFILE.PHONE') + ' 1'"
            :error-messages="errors.phone"
            :readonly="readonly"
            @input="updateValue('phone', $event)"
          ></phone-input>
        </v-col>
        <v-col cols="12" xs="12" md="4">
          <phone-input
            v-model="form.phone_additional"
            :label="$t('PROFILE.PHONE') + ' 2'"
            :error-messages="errors.phone_additional"
            :readonly="readonly"
            @input="updateValue('phone_additional', $event)"
          ></phone-input>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" xs="12" md="4">
          <v-text-field
            v-model="form.email"
            :label="`${$t('PROFILE.EMAIL')}`"
            :error-messages="errors.email"
            :rules="rules.email"
            :readonly="readonly"
            @input="updateValue('email', $event)"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" md="4">
          <v-text-field
            v-model="form.site"
            :label="$t('PROFILE.SITE')"
            :error-messages="errors.site"
            :readonly="readonly"
            @input="updateValue('site', $event)"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" md="4">
          <v-text-field
            v-model="form.email_additional"
            :error-messages="errors.email_additional"
            :rules="rules.email"
            :label="`${$t('COMPANIES.EMAIL_FOR_FORMS')}`"
            :readonly="readonly"
            @input="updateValue('email_additional', $event)"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" xs="12" md="4">
          <v-text-field
            v-model="form.street"
            :label="$t('PROFILE.STREET')"
            :error-messages="errors.street"
            :readonly="readonly"
            @input="updateValue('street', $event)"
          ></v-text-field>
        </v-col>

        <v-col cols="12" xs="12" md="4">
          <zip-code-input
            v-model="form.zip"
            :readonly="readonly"
            :error-messages="errors.zip"
            @input="updateValue('zip', $event)"
          />
        </v-col>

        <v-col cols="12" xs="12" md="4">
          <v-text-field
            v-model="form.city"
            :label="$t('PROFILE.CITY')"
            :error-messages="errors.city"
            :readonly="readonly"
            @input="updateValue('city', $event)"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <v-card min-height="142" elevation="0" class="mt-2">
            <v-card-text class="pa-0">
              <company-tabs-form
                v-model="form"
                :readonly="readonly"
                :errors="errors"
                @input="emitter"
                @update-prop="updateProp(...arguments)"
                @removeFile="$emit('removeFile', $event)"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" xs="12" md="2">
      <comapny-image
        v-model="form.logoPdf"
        class="mt-2"
        :label="$t('COMPANIES.PDF_LOGO')"
        :url="getUrl"
        :name="form.name"
        prepend-icon="mdi-camera"
        chips
        show-size
        :readonly="readonly"
        destroyed
        @uploadIds="form.logo_pdf_id = $event"
        @removeFile="$emit('removeFile', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mask } from 'vue-the-mask';
import formEditable from '@/modules/_global/mixins/form-editable';
import CompanyTabsForm from '@/modules/companies/components/Company/CompanyTabsForm';
import PhoneInput from '@/modules/_global/_components/phone/PhoneInput';
import { mapCacheActions } from 'vuex-cache';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import {
  requiredTextLine,
  requiredSelectArray,
  textDescription,
  requiredEmail,
  email
} from '@/modules/_global/variables/rules.js';
import ComapnyImage from '@/modules/companies/components/Image/ComapnyImage';
import company from '@/modules/companies/mixins/company';
import ZipCodeInput from '@/modules/_global/_components/zip/ZipCodeInput';
const url = `uploads/companies`;
export default {
  name: 'CompanyForm',

  directives: {
    mask
  },

  components: {
    ZipCodeInput,
    ComapnyImage,
    CompanyTabsForm,
    PhoneInput
  },

  mixins: [formEditable, i18nRefreshData, company],

  data() {
    return {
      form: {},
      types: [],
      statuses: [],
      languages: [],
      rules: {
        requiredTextLine,
        requiredSelectArray,
        textDescription,
        requiredEmail,
        email
      }
    };
  },

  computed: {
    getUrl() {
      return url;
    }
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapCacheActions('company', ['getCompanyTypes', 'getCompanyStatuses']),
    ...mapCacheActions('localization', ['retrieveLanguages']),

    setLanguages() {
      this.retrieveLanguages().then(data => {
        this.languages = data.data;
      });
    },

    setCompanyTypes() {
      this.getCompanyTypes().then(({ data }) => {
        this.types = data;
      });
    },

    setCompanyStatuses() {
      this.getCompanyStatuses().then(({ data }) => {
        this.statuses = data.data;
      });
    },

    refreshData() {
      this.setCompanyTypes();
      this.setCompanyStatuses();
      this.setLanguages();
    }
  }
};
</script>

<style scoped></style>
